import React from "react";
import FeedbackButtons from "./FeedbackButtons";
import CollapsibleCSVTable from "./CollapsibleCSVTable";
import SummaryPanel from "./SummaryPanel";
import WGEDRLineChart from "./WGEDRLineChart";
import { processTimelineData } from "../util";
import { disclaimer } from "../config";

const AnalysisPanel = ({ data, loading, setCommentModalData, traceID }) => {
  // Process timeline for formatted display
  let processedTimeline = [];
  if (data?.summarized_timeline) {
    processedTimeline = processTimelineData(data.summarized_timeline);
  }

  return (
    <div className="analysis-column">
      <div className="header analysis-header">Automated Investigation Engine Analysis</div>
      {/* Timeline */}
      {processedTimeline.length > 0 && (
        <div className="analysis-section timeline-section">
          <SummaryPanel
            data={
              <div>
                <div className="disclaimer">{disclaimer}</div>
                <ul>
                  {processedTimeline.map((item, idx) => (
                    <li key={idx}>{`${item.timestamp} — ${item.affectedAsset} — ${item.occurrence}`}</li>
                  ))}
                </ul>
              </div>
            }
            loading={loading}
            heading="Timeline"
            setCommentModalData={setCommentModalData}
            traceID={traceID}
            module="Timeline"
            feedbackModalText={processedTimeline
              .map((item) => `${item.timestamp} — ${item.affectedAsset} — ${item.occurrence}`)
              .join("\n")}
          />
        </div>
      )}
      {/* pfs_artifacts */}
      {Array.isArray(data?.pfs_artifacts) && data.pfs_artifacts.map((artifact, idx) => (
        <div className="analysis-section artifact-section" key={idx}>
          <div className="section-title">{artifact.title}</div>
          {artifact.subtitle && <div className="section-subtitle">{artifact.subtitle}</div>}
          <FeedbackButtons
            traceID={traceID}
            sectionData={{ module: artifact.title, text: artifact.text || artifact.subtitle || "" }}
            setCommentModalData={setCommentModalData}
            agent="wgedr"
          />
          {/* Plot */}
          {artifact.value === "pfs_scores_plot" && artifact.plot && (
            <div className="wgedr-chart-container">
              <div className="y-axis-label">Score</div>
              <div className="chart-and-x-label">
                <WGEDRLineChart plot={artifact.plot} />
                <div className="x-axis-label">Time (UTC)</div>
              </div>
            </div>
          )}
          {/* Text/Links */}
          {artifact.value === "pfs_links" && artifact.text && (
            <div className="wgedr-artifact-text">{artifact.text}</div>
          )}
          {/* Data Table + Text for pfs_logs */}
          {artifact.value === "pfs_logs" && (
            <>
              {artifact.text && (
                <div className="wgedr-artifact-text">{artifact.text}</div>
              )}
              {artifact.data && (
                <div className="wgedr-artifact-data-table">
                  <CollapsibleCSVTable data={artifact.data} />
                </div>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AnalysisPanel; 
